//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import { useTranslation } from 'react-i18next';


// IMPORTAÇÃO DOS COMPONENTES ---------------------------------------------------
import { useState, useEffect } from "react";
import styles from "./userSettings.module.css";
import Preferencias from './components/preferencias.js';
import Conta from './components/conta.js';
import Plano from './components/plano.js';
import { useAppContext } from "../../../../AppContext.js";



// IMPORTAÇÃO ICONES-----------------------------------------------------------
import { GoArrowLeft } from "react-icons/go";



//COMPONENTE-------------------------------------------------------------------
export default function UserSettings({ onClose, reloadMessages }) {
  const [activeMenu, setActiveMenu] = useState("Conta");
  // Hook de tradução
  const { t } = useTranslation();
  // Hook do contexto
  const { isApp } = useAppContext();

  // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);

    // Função de limpeza
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);



  //html do componente
  return (
    <div className={styles.container}>
      <aside className={styles.sidebar}>
        <div className={`${styles.headerSettings} ${isApp ? styles.headerSettingsApp : ''}`}>
          <GoArrowLeft className={styles.xClose} onClick={onClose} title={t('Close')} />
          <h2>{t('Settings')}</h2>
        </div>
        <ul>
          <li
            className={activeMenu === "Conta" ? styles.active : ""}
            onClick={() => setActiveMenu("Conta")}
          >
            {t('Account')}
          </li>
          {/* <li
            className={activeMenu === "Plano" ? styles.active : ""}
            onClick={() => setActiveMenu("Plano")}
          >
            {t('Plan')}
          </li> */}
          <li
            className={activeMenu === "Preferências" ? styles.active : ""}
            onClick={() => setActiveMenu("Preferências")}
          >
            {t('Preferences')}
          </li>
        </ul>
        <button
          className={styles.backButton}
          onClick={onClose}
        >
          {t('Return')}
        </button>
      </aside>
      <main className={styles.content}>
        {activeMenu === "Conta" && (
          <Conta />
        )}
        {activeMenu === "Plano" && (
          <Plano />
        )}
        {activeMenu === "Preferências" && (
          <Preferencias />
        )}
      </main>
    </div>
  );
}